export default "__VITE_ASSET__0c121c39__"